"use client";

import { useMemo } from "react";
import {
  getAvailablePaymentMethods,
  getPaymentProvider,
} from "./paymentRegistry";
import type {
  PaymentMethodId,
  InitPaymentParams,
  InitPaymentResult,
} from "./types";

/**
 * Hook to access the active payment provider and available methods.
 */
export function usePaymentProvider() {
  const provider = useMemo(() => getPaymentProvider(), []);

  const methods = useMemo(() => getAvailablePaymentMethods(), []);
  const methodsLoading = false;

  const initPayment = async (
    params: Omit<InitPaymentParams, "methodId"> & { methodId: PaymentMethodId }
  ): Promise<InitPaymentResult> => {
    if (!provider.supportsMethod(params.methodId)) {
      return { success: false, error: "Payment method not supported" };
    }
    return provider.initPayment(params);
  };

  return {
    methods,
    methodsLoading,
    provider,
    initPayment,
  };
}
